import React from "react";
import { primaryColor } from "../../Theme";

interface ChatbotIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export const ChatbotIcon: React.FC<ChatbotIconProps> = ({
  color = primaryColor,
  style = {},
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 48 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M17.0174 22.1696C18.6339 22.1696 19.9444 24.166 19.9444 26.6285C19.9444 29.0911 18.6339 31.0874 17.0174 31.0874C15.4009 31.0874 14.0904 29.0911 14.0904 26.6285C14.0904 24.166 15.4009 22.1696 17.0174 22.1696Z"
      fill={color}
    />
    <path
      d="M30.396 22.1696C32.0126 22.1696 33.3231 24.166 33.3231 26.6285C33.3231 29.0911 32.0126 31.0874 30.396 31.0874C28.7795 31.0874 27.4691 29.091 27.4691 26.6285C27.4691 24.166 28.7796 22.1696 30.396 22.1696Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.2957 2.70441C21.2957 1.10924 22.6768 -0.163386 24.3084 0.0170931C25.5308 0.15231 26.5231 1.12391 26.6809 2.34356C26.8462 3.62104 26.119 4.75239 25.037 5.20199C24.863 5.27429 24.7603 5.4552 24.7857 5.64184L25.1104 8.02012C25.1369 8.21439 25.2958 8.36387 25.4913 8.37927C27.3351 8.52449 28.5684 8.98217 29.3927 9.72953C29.5891 9.90749 29.8375 10.0181 30.1012 10.0438C37.5713 10.7718 42.2984 13.2138 44.1553 19.4171C44.254 19.7469 44.5073 20.0051 44.8334 20.1152C47.0018 20.8472 48 22.5727 48 26.6285C48 30.6847 47.0017 32.4103 44.8329 33.1421C44.507 33.2521 44.2536 33.5098 44.155 33.8393C42.9561 37.8435 40.5617 40.2808 37.0056 41.7014L37.0078 41.7019C30.7219 44.2813 22.5023 47.2925 19.8702 48.2486C19.4568 48.3987 19.0206 48.0923 19.0206 47.6525V43.9884C19.0205 43.6133 18.697 43.2833 18.3095 43.2523L18.3954 43.2592C10.6379 42.5911 5.7426 40.1798 3.84479 33.8402C3.746 33.5103 3.49254 33.2519 3.16622 33.1418C0.99805 32.4097 2.38526e-06 30.6841 0 26.6285C8.36341e-06 22.5729 0.998048 20.8474 3.16622 20.1154C3.49258 20.0052 3.746 19.7468 3.84479 19.4168C5.70181 13.2135 10.4289 10.7716 17.8991 10.0435C18.1628 10.0178 18.4112 9.90724 18.6075 9.72931C19.4317 8.98215 20.6649 8.52465 22.5081 8.37939C22.7036 8.36397 22.8625 8.21447 22.8891 8.02023L23.214 5.64196C23.2397 5.45427 23.1352 5.27364 22.9603 5.20075C21.9829 4.79332 21.2957 3.82944 21.2957 2.70441ZM24.0001 15.8392C18.0401 15.8392 14.3102 16.5086 12.2618 17.946C11.3538 18.5832 10.7154 19.4197 10.2529 20.5785C9.65862 22.0671 9.35735 24.1026 9.35735 26.6285C9.35735 29.1544 9.65861 31.19 10.2529 32.6787C10.7154 33.8374 11.3538 34.674 12.2618 35.3111C14.3101 36.7485 18.0401 37.4179 24.0001 37.4179C29.9601 37.4179 33.6901 36.7485 35.7384 35.3111C36.6463 34.674 37.2846 33.8374 37.7473 32.6787C38.3415 31.19 38.6428 29.1544 38.6428 26.6285C38.6428 24.1026 38.3415 22.0671 37.7473 20.5785C37.2846 19.4197 36.6463 18.5832 35.7384 17.946C33.69 16.5086 29.9601 15.8392 24.0001 15.8392Z"
      fill={color}
    />
  </svg>
);

export default ChatbotIcon;
